// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"lA-z","smallCardRow":"mA-z","largeCardRow":"nA-z","productSearchRow":"oA-z","curatedRow":"pA-z"};